namespace RioERP.Wallet {
    export namespace PermissionKeys {
        export const General = "Wallet:General";

        namespace WalletManagement {
            export const Delete = "Wallet:WalletManagement:Delete";
            export const Modify = "Wallet:WalletManagement:Modify";
            export const View = "Wallet:WalletManagement:View";
        }
    }
}
